const $ = window.jQuery;

if ( $( '.hero-bear-slider' ).length ) {

	const prevArrow = `<button class="slick-prev slick-arrow">
		<svg viewBox="0 0 16 24">
			<path d="M13,2 L3,12 L13,22" stroke="#feda01" stroke-width="4" stroke-linecap="round" fill="none"/>
		</svg>
	</button>`;

	const nextArrow = `<button class="slick-next slick-arrow">
		<svg viewBox="0 0 16 24">
			<path d="M3,2 L13,12 L3,22" stroke="#feda01" stroke-width="4" stroke-linecap="round" fill="none"/>
		</svg>
	</button>`;

	$( '.hero-bear-slider' ).slick( {
		arrows       : true,
		slidesToShow : 1,
		mobileFirst  : true,
		prevArrow    : prevArrow,
		nextArrow    : nextArrow,
		infinite     : true,
		responsive   : [
			{
				breakpoint : 767,
				settings   : {
					slidesToShow: 3,
				}
			},
		]
	} );

}
